<template>
  <div>
    <acheader></acheader>
    <div class="row mainbody">
      <div class="col-lg-2 col-md-4 col-sm-12">
        <clientsidebar></clientsidebar>
      </div>
      <div class="col-lg-10 col-md-8 col-sm-12">
        <div class="moduleWrapper form" v-if="cli!==null">
          <div class="moduleCard">
            <div class="row">
              <div class="field col-md-6 mb-3">
                <label class="text-dark" id="email_address">Email Address:</label><br />
                <input class="mb-0" type="text" id="emailAddress" aria-label="The email address associated with your account" disabled="true" v-model.trim="cli.EmailAddress">
              </div>
              <div class="field col-md-6 mb-3">
                <label class="text-dark" id="avatar_image">Avatar Image:</label><br />
                <div class="row">
                  <div class="col-12">
                    <img v-bind:src="cli.FullImage" width="50" height="50" onerror="this.src='/genericAvatar.png'" />&nbsp;&nbsp;
                    <input type='file' id='fileinput' ref="tfiles" class='w50 ib mb-0' @change="getFile" />
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="field col-md-6 mb-3">
                <label class="text-dark" id="firstname">First Name:</label><br />
                <input id="firstName" class="mb-0" type="text" aria-label="Your first name" v-model.trim="cli.FirstName" :disabled="isDisabled">
              </div>
              <div class="field col-md-6 mb-3">
                <label class="text-dark" id="lastname">Last Name:</label><br />
                <input id="lastName" class="mb-0" type="text" aria-label="Your last name" v-model.trim="cli.LastName" :disabled="isDisabled">
              </div>
              <div class="field col-md-6 mb-3">
                <label class="text-dark" id="middlename">Middle Name:</label><br />
                <input id="middleName" class="mb-0" type="text" aria-label="Your middle name" v-model.trim="cli.MiddleName" :disabled="isDisabled">
              </div>
              <div class="field col-md-6 mb-3">
                <label class="text-dark" id="membername_displayformat">Member Name Display Format:</label><br />
                <select class="w25" v-model="cli.NameFormat">
                  <option value="2">No Preference</option>
                  <option value="0">First Last</option>
                  <option value="1">Last, First</option>
                </select>
              </div>
            </div>

            <div class="row">
              <div class="field col-md-6 mb-3">
                <label class="text-dark" id="excludefrom_reports">Exclude From Reports:</label><br />
                <input id="excludeFromReports" type="checkbox" class="mb-0 checkbox" aria-label="Exclude from reports" v-model="cli.ExcludeFromReports" :disabled="isDisabled">
              </div>
              <div class="field col-md-6 mb-3">
                <label class="text-dark" id="language">Language:</label><br />
                <select id='ddlLanguage' class="mb-0" v-model="cli.LanguageID" :disabled="isDisabled">
                  <option v-for="lg in Languages" v-bind:value="lg.LanguageID">{{lg.LanguageName}}</option>
                </select>
              </div>
            </div>

            <div class="address row">
              <div class="field col-md-6 mb-3">
                <label class="text-dark" id="street_address1">Street Address 1:</label><br />
                <input class="mb-0" type="text" id="streetAddress1" aria-label="Enter street address line 1 here" v-model.trim="cli.StreetAddress1" :disabled="isDisabled">
              </div>
              <div class="field col-md-6 mb-3">
                <label class="text-dark" id="street_address2">Street Address 2:</label><br />
                <input class="mb-0" type="text" id="streetAddress2" aria-label="Enter street address line 2 here" v-model.trim="cli.StreetAddress2" :disabled="isDisabled">
              </div>
              <div class="field col-md-6 mb-3">
                <label class="text-dark" id="city">City:</label><br />
                <input class="mb-0" type="text" id="city" aria-label="Enter city here" v-model.trim="cli.City" :disabled="isDisabled">
              </div>
              <div class="field col-md-6 mb-3">
                <label class="text-dark" id="state">State:</label><br />
                <select class="mb-0" id="state" aria-label="Choose your state here" v-model.trim="cli.State" :disabled="isDisabled">

                  <option value="AL">Alabama</option>
                  <option value="AK">Alaska</option>
                  <option value="AZ">Arizona</option>
                  <option value="AR">Arkansas</option>
                  <option value="CA">California</option>
                  <option value="CO">Colorado</option>
                  <option value="CT">Connecticut</option>
                  <option value="DE">Delaware</option>
                  <option value="DC">District Of Columbia</option>
                  <option value="FL">Florida</option>
                  <option value="GA">Georgia</option>
                  <option value="HI">Hawaii</option>
                  <option value="ID">Idaho</option>
                  <option value="IL">Illinois</option>
                  <option value="IN">Indiana</option>
                  <option value="IA">Iowa</option>
                  <option value="KS">Kansas</option>
                  <option value="KY">Kentucky</option>
                  <option value="LA">Louisiana</option>
                  <option value="ME">Maine</option>
                  <option value="MD">Maryland</option>
                  <option value="MA">Massachusetts</option>
                  <option value="MI">Michigan</option>
                  <option value="MN">Minnesota</option>
                  <option value="MS">Mississippi</option>
                  <option value="MO">Missouri</option>
                  <option value="MT">Montana</option>
                  <option value="NE">Nebraska</option>
                  <option value="NV">Nevada</option>
                  <option value="NH">New Hampshire</option>
                  <option value="NJ">New Jersey</option>
                  <option value="NM">New Mexico</option>
                  <option value="NY">New York</option>
                  <option value="NC">North Carolina</option>
                  <option value="ND">North Dakota</option>
                  <option value="OH">Ohio</option>
                  <option value="OK">Oklahoma</option>
                  <option value="OR">Oregon</option>
                  <option value="PA">Pennsylvania</option>
                  <option value="RI">Rhode Island</option>
                  <option value="SC">South Carolina</option>
                  <option value="SD">South Dakota</option>
                  <option value="TN">Tennessee</option>
                  <option value="TX">Texas</option>
                  <option value="UT">Utah</option>
                  <option value="VT">Vermont</option>
                  <option value="VA">Virginia</option>
                  <option value="WA">Washington</option>
                  <option value="WV">West Virginia</option>
                  <option value="WI">Wisconsin</option>
                  <option value="WY">Wyoming</option>

                </select>
              </div>
              <div class="field col-md-6 mb-3">
                <label class="text-dark" id="zip">Zip:</label><br />
                <input type="text" id="zip" aria-label="Enter zip code here" v-model.trim="cli.Zip" :disabled="isDisabled">
              </div>
              <div class="field col-md-6 mb-3">
                <label class="text-dark" id="timezone">Time Zone:</label><br />
                <b-form-select :options="timezones" v-model="timezone"></b-form-select>
              </div>
            </div>
            <div class="row">
              <div class="col-6 text-left">
                <button id="btnChangePWD" class="btn btn-secondary btn-medium" @click="doResetPassword" v-show="!isDisabled">Reset Password</button>
              </div>
              <div class="col-6 text-right">
                <button class="btn btn-primary btn-short doublefixmargin" @click="doSave" id="btnsave">Save</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
    </div><acfooter></acfooter>
    <b-modal ref="pReset" title="Reset Password" @ok="completePasswordReset">
      <div class="mb-3">
        <label class="text-dark">Old Password:</label><br />
        <input type="password" aria-label="Type old password here" class="fullWidth" v-model="opass">
      </div>
      <div class="mb-3">
        <label class="text-dark">New Password:</label><br />
        <input type="password" aria-label="Type new password here" class="fullWidth" v-model="npass">
      </div>
      <div class="mb-3">
        <label class="text-dark">Re-type New Password:</label><br />
        <input type="password" aria-label="Re-type new password here" class="fullWidth" v-model="rnpass">
      </div>
    </b-modal>
  </div>
</template>

<script>
  import acheader from "../../layout/Header.vue"
  import acfooter from "../../layout/Footer.vue"
  import clientsidebar from "../../layout/Client/Sidebar.vue"
  import * as mylib from '../../languageText.js';
  
  export default {
    name: 'MyAccount',
    components: { acheader, acfooter, clientsidebar },
    data() {
      return {
        fdata: null,
        cli: null,
        npass: null,
        opass: null,
        rnpass: null,
        timezone: null,
        timezones: null,
        Languages: null,
        selectedLanguage: null,
        defaultselected: "00000000-0000-0000-0000-000000000000"
      }
    },
    methods: {

      completePasswordReset() {

        try {
          if (this.npass !== this.rnpass) {
            this.popDialog(1, "The typed and re-typed passwords do not match");
          }
          else if (this.npass.length < 11) {
            this.popDialog(1, "The new password must be at least 11 characters");
          }
          else {

            this.apiCommand(
              [
                {
                  Operation: "Client",
                  Function: "ChangePassword",
                  Fields: {
                    OldPassword: this.opass,
                    NewPassword: this.npass
                  }
                }
              ]).then(response => {

                var shellData = JSON.parse(response.CommandResult);

                if (shellData.returnObjects[0].returnObject === "OK") {
                  this.popDialog(0, "Password changed successfully");
                }
                else {
                  this.popDialog(1, "Failed to change password: " + shellData.returnObjects[0].returnObject);
                }


              });


          }
        }
        catch (e) {
          this.popDialog(1, "Error: Please ensure all fields are filled out correctly");
        }
      },
      doResetPassword() {
        this.$refs["pReset"].show();
      },
      doSave() {

        if (this.cli.LanguageID === null) {
          this.popDialog(1, "Please select a language");
          return;
        }

        var fields = {
          ClientID: this.cli.ClientID,
          FirstName: this.cli.FirstName,
          LastName: this.cli.LastName,
          MiddleName: this.cli.MiddleName,
          StreetAddress1: this.cli.StreetAddress1,
          StreetAddress2: this.cli.StreetAddress2,
          City: this.cli.City,
          State: this.cli.State,
          Zip: this.cli.Zip,
          Phone: this.cli.Phone,
          TimeOffset: this.timezone,
          ExcludeFromReports: this.cli.ExcludeFromReports ? "true" : "false",
          NameFormat: this.cli.NameFormat,
          LanguageID: this.cli.LanguageID
        };

        if (this.fdata != null) {
          fields.ClientImage = this.fdata.split(',')[1];
        }

        this.apiCommand([
          {
            Operation: "Client",
            Function: "Edit",
            Fields: fields
          }
        ]).then(response => {

          var cr = JSON.parse(response.CommandResult);

          if (cr.returnObjects[0].returnObject === "OK") {
            this.udata.ClientName = this.cli.FirstName;
            this.udata.NameFormat = this.cli.NameFormat === 2 ? null : this.cli.NameFormat;
            localStorage.setItem("udata", JSON.stringify(this.udata));
            this.cli.FullImage = "https://attachments.simmersion.com/" + this.cli.ClientID + ".png?r=" + Math.random(0, 100000);
            this.popDialog(0, "Profile information saved successfully");
            this.$bus.$emit("AvatarUpdateEvent", this.udata);
            this.$bus.$emit("ClientSidebarUpdateEvent", this.udata.ClientName, this.udata.ClientID);
          }
          else {
            this.popDialog(1, "An error occurred while saving your information: " + cr.returnObjects[0].returnObject);
          }

        });
      },
      fillTimezones() {
        this.timezones = [{ value: '(UTC-12:00) International Date Line West', text: '(UTC-12:00) International Date Line West' }, { value: '(UTC-11:00) Coordinated Universal Time-11', text: '(UTC-11:00) Coordinated Universal Time-11' }, { value: '(UTC-10:00) Aleutian Islands', text: '(UTC-10:00) Aleutian Islands' }, { value: '(UTC-10:00) Hawaii', text: '(UTC-10:00) Hawaii' }, { value: '(UTC-09:30) Marquesas Islands', text: '(UTC-09:30) Marquesas Islands' }, { value: '(UTC-09:00) Alaska', text: '(UTC-09:00) Alaska' }, { value: '(UTC-09:00) Coordinated Universal Time-09', text: '(UTC-09:00) Coordinated Universal Time-09' }, { value: '(UTC-08:00) Baja California', text: '(UTC-08:00) Baja California' }, { value: '(UTC-08:00) Coordinated Universal Time-08', text: '(UTC-08:00) Coordinated Universal Time-08' }, { value: '(UTC-08:00) Pacific Time (US & Canada)', text: '(UTC-08:00) Pacific Time (US & Canada)' }, { value: '(UTC-07:00) Arizona', text: '(UTC-07:00) Arizona' }, { value: '(UTC-07:00) Chihuahua, La Paz, Mazatlan', text: '(UTC-07:00) Chihuahua, La Paz, Mazatlan' }, { value: '(UTC-07:00) Mountain Time (US & Canada)', text: '(UTC-07:00) Mountain Time (US & Canada)' }, { value: '(UTC-06:00) Central America', text: '(UTC-06:00) Central America' }, { value: '(UTC-06:00) Central Time (US & Canada)', text: '(UTC-06:00) Central Time (US & Canada)' }, { value: '(UTC-06:00) Easter Island', text: '(UTC-06:00) Easter Island' }, { value: '(UTC-06:00) Guadalajara, Mexico City, Monterrey', text: '(UTC-06:00) Guadalajara, Mexico City, Monterrey' }, { value: '(UTC-06:00) Saskatchewan', text: '(UTC-06:00) Saskatchewan' }, { value: '(UTC-05:00) Bogota, Lima, Quito, Rio Branco', text: '(UTC-05:00) Bogota, Lima, Quito, Rio Branco' }, { value: '(UTC-05:00) Chetumal', text: '(UTC-05:00) Chetumal' }, { value: '(UTC-05:00) Eastern Time (US & Canada)', text: '(UTC-05:00) Eastern Time (US & Canada)' }, { value: '(UTC-05:00) Haiti', text: '(UTC-05:00) Haiti' }, { value: '(UTC-05:00) Havana', text: '(UTC-05:00) Havana' }, { value: '(UTC-05:00) Indiana (East)', text: '(UTC-05:00) Indiana (East)' }, { value: '(UTC-05:00) Turks and Caicos', text: '(UTC-05:00) Turks and Caicos' }, { value: '(UTC-04:00) Asuncion', text: '(UTC-04:00) Asuncion' }, { value: '(UTC-04:00) Atlantic Time (Canada)', text: '(UTC-04:00) Atlantic Time (Canada)' }, { value: '(UTC-04:00) Caracas', text: '(UTC-04:00) Caracas' }, { value: '(UTC-04:00) Cuiaba', text: '(UTC-04:00) Cuiaba' }, { value: '(UTC-04:00) Georgetown, La Paz, Manaus, San Juan', text: '(UTC-04:00) Georgetown, La Paz, Manaus, San Juan' }, { value: '(UTC-04:00) Santiago', text: '(UTC-04:00) Santiago' }, { value: '(UTC-03:30) Newfoundland', text: '(UTC-03:30) Newfoundland' }, { value: '(UTC-03:00) Araguaina', text: '(UTC-03:00) Araguaina' }, { value: '(UTC-03:00) Brasilia', text: '(UTC-03:00) Brasilia' }, { value: '(UTC-03:00) Cayenne, Fortaleza', text: '(UTC-03:00) Cayenne, Fortaleza' }, { value: '(UTC-03:00) City of Buenos Aires', text: '(UTC-03:00) City of Buenos Aires' }, { value: '(UTC-03:00) Greenland', text: '(UTC-03:00) Greenland' }, { value: '(UTC-03:00) Montevideo', text: '(UTC-03:00) Montevideo' }, { value: '(UTC-03:00) Punta Arenas', text: '(UTC-03:00) Punta Arenas' }, { value: '(UTC-03:00) Saint Pierre and Miquelon', text: '(UTC-03:00) Saint Pierre and Miquelon' }, { value: '(UTC-03:00) Salvador', text: '(UTC-03:00) Salvador' }, { value: '(UTC-02:00) Coordinated Universal Time-02', text: '(UTC-02:00) Coordinated Universal Time-02' }, { value: '(UTC-02:00) Mid-Atlantic - Old', text: '(UTC-02:00) Mid-Atlantic - Old' }, { value: '(UTC-01:00) Azores', text: '(UTC-01:00) Azores' }, { value: '(UTC-01:00) Cabo Verde Is.', text: '(UTC-01:00) Cabo Verde Is.' }, { value: '(UTC) Coordinated Universal Time', text: '(UTC) Coordinated Universal Time' }, { value: '(UTC+00:00) Dublin, Edinburgh, Lisbon, London', text: '(UTC+00:00) Dublin, Edinburgh, Lisbon, London' }, { value: '(UTC+00:00) Monrovia, Reykjavik', text: '(UTC+00:00) Monrovia, Reykjavik' }, { value: '(UTC+00:00) Sao Tome', text: '(UTC+00:00) Sao Tome' }, { value: '(UTC+01:00) Casablanca', text: '(UTC+01:00) Casablanca' }, { value: '(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna', text: '(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna' }, { value: '(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague', text: '(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague' }, { value: '(UTC+01:00) Brussels, Copenhagen, Madrid, Paris', text: '(UTC+01:00) Brussels, Copenhagen, Madrid, Paris' }, { value: '(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb', text: '(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb' }, { value: '(UTC+01:00) West Central Africa', text: '(UTC+01:00) West Central Africa' }, { value: '(UTC+02:00) Amman', text: '(UTC+02:00) Amman' }, { value: '(UTC+02:00) Athens, Bucharest', text: '(UTC+02:00) Athens, Bucharest' }, { value: '(UTC+02:00) Beirut', text: '(UTC+02:00) Beirut' }, { value: '(UTC+02:00) Cairo', text: '(UTC+02:00) Cairo' }, { value: '(UTC+02:00) Chisinau', text: '(UTC+02:00) Chisinau' }, { value: '(UTC+02:00) Damascus', text: '(UTC+02:00) Damascus' }, { value: '(UTC+02:00) Gaza, Hebron', text: '(UTC+02:00) Gaza, Hebron' }, { value: '(UTC+02:00) Harare, Pretoria', text: '(UTC+02:00) Harare, Pretoria' }, { value: '(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius', text: '(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius' }, { value: '(UTC+02:00) Jerusalem', text: '(UTC+02:00) Jerusalem' }, { value: '(UTC+02:00) Kaliningrad', text: '(UTC+02:00) Kaliningrad' }, { value: '(UTC+02:00) Khartoum', text: '(UTC+02:00) Khartoum' }, { value: '(UTC+02:00) Tripoli', text: '(UTC+02:00) Tripoli' }, { value: '(UTC+02:00) Windhoek', text: '(UTC+02:00) Windhoek' }, { value: '(UTC+03:00) Baghdad', text: '(UTC+03:00) Baghdad' }, { value: '(UTC+03:00) Istanbul', text: '(UTC+03:00) Istanbul' }, { value: '(UTC+03:00) Kuwait, Riyadh', text: '(UTC+03:00) Kuwait, Riyadh' }, { value: '(UTC+03:00) Minsk', text: '(UTC+03:00) Minsk' }, { value: '(UTC+03:00) Moscow, St. Petersburg', text: '(UTC+03:00) Moscow, St. Petersburg' }, { value: '(UTC+03:00) Nairobi', text: '(UTC+03:00) Nairobi' }, { value: '(UTC+03:30) Tehran', text: '(UTC+03:30) Tehran' }, { value: '(UTC+04:00) Abu Dhabi, Muscat', text: '(UTC+04:00) Abu Dhabi, Muscat' }, { value: '(UTC+04:00) Astrakhan, Ulyanovsk', text: '(UTC+04:00) Astrakhan, Ulyanovsk' }, { value: '(UTC+04:00) Baku', text: '(UTC+04:00) Baku' }, { value: '(UTC+04:00) Izhevsk, Samara', text: '(UTC+04:00) Izhevsk, Samara' }, { value: '(UTC+04:00) Port Louis', text: '(UTC+04:00) Port Louis' }, { value: '(UTC+04:00) Saratov', text: '(UTC+04:00) Saratov' }, { value: '(UTC+04:00) Tbilisi', text: '(UTC+04:00) Tbilisi' }, { value: '(UTC+04:00) Volgograd', text: '(UTC+04:00) Volgograd' }, { value: '(UTC+04:00) Yerevan', text: '(UTC+04:00) Yerevan' }, { value: '(UTC+04:30) Kabul', text: '(UTC+04:30) Kabul' }, { value: '(UTC+05:00) Ashgabat, Tashkent', text: '(UTC+05:00) Ashgabat, Tashkent' }, { value: '(UTC+05:00) Ekaterinburg', text: '(UTC+05:00) Ekaterinburg' }, { value: '(UTC+05:00) Islamabad, Karachi', text: '(UTC+05:00) Islamabad, Karachi' }, { value: '(UTC+05:00) Qyzylorda', text: '(UTC+05:00) Qyzylorda' }, { value: '(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi', text: '(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi' }, { value: '(UTC+05:30) Sri Jayawardenepura', text: '(UTC+05:30) Sri Jayawardenepura' }, { value: '(UTC+05:45) Kathmandu', text: '(UTC+05:45) Kathmandu' }, { value: '(UTC+06:00) Astana', text: '(UTC+06:00) Astana' }, { value: '(UTC+06:00) Dhaka', text: '(UTC+06:00) Dhaka' }, { value: '(UTC+06:00) Omsk', text: '(UTC+06:00) Omsk' }, { value: '(UTC+06:30) Yangon (Rangoon)', text: '(UTC+06:30) Yangon (Rangoon)' }, { value: '(UTC+07:00) Bangkok, Hanoi, Jakarta', text: '(UTC+07:00) Bangkok, Hanoi, Jakarta' }, { value: '(UTC+07:00) Barnaul, Gorno-Altaysk', text: '(UTC+07:00) Barnaul, Gorno-Altaysk' }, { value: '(UTC+07:00) Hovd', text: '(UTC+07:00) Hovd' }, { value: '(UTC+07:00) Krasnoyarsk', text: '(UTC+07:00) Krasnoyarsk' }, { value: '(UTC+07:00) Novosibirsk', text: '(UTC+07:00) Novosibirsk' }, { value: '(UTC+07:00) Tomsk', text: '(UTC+07:00) Tomsk' }, { value: '(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi', text: '(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi' }, { value: '(UTC+08:00) Irkutsk', text: '(UTC+08:00) Irkutsk' }, { value: '(UTC+08:00) Kuala Lumpur, Singapore', text: '(UTC+08:00) Kuala Lumpur, Singapore' }, { value: '(UTC+08:00) Perth', text: '(UTC+08:00) Perth' }, { value: '(UTC+08:00) Taipei', text: '(UTC+08:00) Taipei' }, { value: '(UTC+08:00) Ulaanbaatar', text: '(UTC+08:00) Ulaanbaatar' }, { value: '(UTC+08:45) Eucla', text: '(UTC+08:45) Eucla' }, { value: '(UTC+09:00) Chita', text: '(UTC+09:00) Chita' }, { value: '(UTC+09:00) Osaka, Sapporo, Tokyo', text: '(UTC+09:00) Osaka, Sapporo, Tokyo' }, { value: '(UTC+09:00) Pyongyang', text: '(UTC+09:00) Pyongyang' }, { value: '(UTC+09:00) Seoul', text: '(UTC+09:00) Seoul' }, { value: '(UTC+09:00) Yakutsk', text: '(UTC+09:00) Yakutsk' }, { value: '(UTC+09:30) Adelaide', text: '(UTC+09:30) Adelaide' }, { value: '(UTC+09:30) Darwin', text: '(UTC+09:30) Darwin' }, { value: '(UTC+10:00) Brisbane', text: '(UTC+10:00) Brisbane' }, { value: '(UTC+10:00) Canberra, Melbourne, Sydney', text: '(UTC+10:00) Canberra, Melbourne, Sydney' }, { value: '(UTC+10:00) Guam, Port Moresby', text: '(UTC+10:00) Guam, Port Moresby' }, { value: '(UTC+10:00) Hobart', text: '(UTC+10:00) Hobart' }, { value: '(UTC+10:00) Vladivostok', text: '(UTC+10:00) Vladivostok' }, { value: '(UTC+10:30) Lord Howe Island', text: '(UTC+10:30) Lord Howe Island' }, { value: '(UTC+11:00) Bougainville Island', text: '(UTC+11:00) Bougainville Island' }, { value: '(UTC+11:00) Chokurdakh', text: '(UTC+11:00) Chokurdakh' }, { value: '(UTC+11:00) Magadan', text: '(UTC+11:00) Magadan' }, { value: '(UTC+11:00) Norfolk Island', text: '(UTC+11:00) Norfolk Island' }, { value: '(UTC+11:00) Sakhalin', text: '(UTC+11:00) Sakhalin' }, { value: '(UTC+11:00) Solomon Is., New Caledonia', text: '(UTC+11:00) Solomon Is., New Caledonia' }, { value: '(UTC+12:00) Anadyr, Petropavlovsk-Kamchatsky', text: '(UTC+12:00) Anadyr, Petropavlovsk-Kamchatsky' }, { value: '(UTC+12:00) Auckland, Wellington', text: '(UTC+12:00) Auckland, Wellington' }, { value: '(UTC+12:00) Coordinated Universal Time+12', text: '(UTC+12:00) Coordinated Universal Time+12' }, { value: '(UTC+12:00) Fiji', text: '(UTC+12:00) Fiji' }, { value: '(UTC+12:00) Petropavlovsk-Kamchatsky - Old', text: '(UTC+12:00) Petropavlovsk-Kamchatsky - Old' }, { value: '(UTC+12:45) Chatham Islands', text: '(UTC+12:45) Chatham Islands' }, { value: '(UTC+13:00) Coordinated Universal Time+13', text: '(UTC+13:00) Coordinated Universal Time+13' }, { value: "(UTC+13:00) Nuku'alofa", text: "(UTC+13:00) Nuku'alofa" }, { value: '(UTC+13:00) Samoa', text: '(UTC+13:00) Samoa' }, { value: '(UTC+14:00) Kiritimati Island', text: '(UTC+14:00) Kiritimati Island' }];
      },
      getFile(event) {

        var r = new FileReader();
        var self = this;
        r.onload = function (e) {
          self.fdata = e.target.result;
        }
        r.readAsDataURL(this.$refs["tfiles"].files[0]);
      }

    },
    mounted() {
      this.doPage().then(r => {

        this.apiCommand([
          {
            Operation: "Client",
            Function: "GetClientByID",
            Fields: {
              ClientID: this.$route.params.id
            }
          }
        ]).then(response => {

          this.bootstrapClient(this.$route.params.id);
          this.fillTimezones();

          var cr = JSON.parse(response.CommandResult);
          var mcli = JSON.parse(cr.returnObjects[0].returnObject);
          mcli.FullImage = "https://attachments.simmersion.com/" + mcli.ClientID + ".png";
          try {
            this.timezone = mcli.TimeOffset.replace("&amp;", "&");
          }
          catch (e) {
            this.timezone = "(UTC) Coordinated Universal Time";
          }
          if (mcli.NameFormat === null) {
            mcli.NameFormat = 2;
          }

          this.cli = mcli;

          

        });




        this.apiCommand([
          {
            Operation: "Product",
            Function: "GetActiveLanguages"
          }
        ]).then(response => {
          var cr = JSON.parse(response.CommandResult);
          var languages = JSON.parse(cr.returnObjects[0].returnObject);

          languages.unshift({
            LanguageID: "00000000-0000-0000-0000-000000000000",
            LanguageName: "English"
          });                     
          
          Window.loadLanguageContent(); 
          this.Languages = languages;

        });      
        
        if (sessionStorage.getItem("isSimmersionUser")) {
          this.popDialog(2, "Account management is handled at the organization level. To make account related changes, please log into the Lifeline Learning Portal and visit the Users page.");
        }

      });
    },
    computed: {
      isDisabled() {
        if (sessionStorage.getItem("isSimmersionUser")) {
          return true;
        }
        else {
          return false;
        }
      }
    }

  }

  
</script>

